var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7154 0.616548L11.3694 0.278907C10.9886 -0.0929691 10.3656 -0.0929691 9.98484 0.278907L4.1024 6.01879L2.01536 3.98272C1.63505 3.61124 1.01156 3.61123 0.631255 3.98311L0.285229 4.32036C-0.0950765 4.69184 -0.0950765 5.29983 0.285229 5.67131L3.40833 8.72109C3.78904 9.09297 4.41213 9.09297 4.79284 8.72109L11.7154 1.9675C12.0949 1.59602 12.0949 0.988031 11.7154 0.616548Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.ed973358e2ca9ccca5e4abdd469cc33f.svg";
export { ForwardRef as ReactComponent };